import React, { Component } from 'react'
//import PropTypes from 'prop-types';
import { Container } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';

//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';



export class DashboardFragments extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
             value: 0
        }
    }
     handleChange = (event, newValue) => {
        this.setState({
          value: newValue
        })
      };
    
    render() {
      return (
        <Container maxWidth="md" fixed>
          <AppBar position="static" color="default">
           
          </AppBar>
          
        </Container>
      );
    }
}

export default DashboardFragments;


